import React, { useEffect, useRef } from "react";
import { FaPlaneDeparture } from "react-icons/fa";
import { motion } from "framer-motion";
import CallHelpCard from "./CallCard";
import StickyCallCard from "./StickyCallCard";

const routes = [
  "Washington DC To Visakhapatnam", "Salt Lake City To Mount Kilimanjaro", "Los Angeles To Hong Kong",
  "Washington D.C. To Beijing", "New York City To Hyderabad", "New York City To Guangzhou",
  "Washington D.C. To New Delhi", "San Diego to Vancouver", "New York City To Rijeka",
  "Rochester To Glasgow", "Orlando To Hyderabad", "Boston To London",
  "Chicago to Edmonton", "Washington D.C. To Ahmedabad", "Raleigh To Vancouver",
  "Dallas To Hyderabad", "New York City To Lisbon", "Boston To Beirut",
  "Washington D.C. To Hyderabad", "Los Angeles To Kochi", "Washington D.C. To Chennai",
  "Chicago To Hyderabad", "New York City To Istanbul", "Washington D.C. To San Salvador",
  "New York City To London", "Chicago To Dubai", "Miami To Cartagena",
  "Atlanta To Puerto Vallarta", "Washington D.C. To Bengaluru", "Seattle To Tokyo",
  "Dallas To Cali", "Chicago To Abu Dhabi", "Washington D.C. To Mumbai",
  "New York City To Toronto", "Buffalo To Glasgow", "Los Angeles To Milan",
  "New York City To Cairo", "Los Angeles To Shanghai", "Houston To Coxen Hole",
  "Chicago To Calgary", "Los Angeles To Dublin", "New York City To Bangkok",
  "Detroit To Amman", "New York City To Paris", "New York City To Beijing"
];

const slugify = (text) =>
  text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

const TopRoutesList = () => {
  const sectionRef = useRef(null);

  // Fade in on scroll
  useEffect(() => {
    const el = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && el.classList.add("fade-visible"),
      { threshold: 0.12 }
    );
    observer.observe(el);
  }, []);

  return (
    <div
      ref={sectionRef}
      className="fade-section bg-[#F9FAF9] rounded-3xl max-w-6xl mx-auto px-6 py-10 shadow-sm"
    >
      <CallHelpCard />

      <motion.h2
        initial={{ opacity: 0, y: -15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-3xl sm:text-4xl font-extrabold text-center mb-10 text-teal-700 tracking-tight"
      >
        🌍 Top International Routes
      </motion.h2>

      {/* Route Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {routes.map((route, idx) => (
          <motion.a
            key={idx}
            href={`/airline-routes/${slugify(route)}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.02, duration: 0.4 }}
            whileHover={{ scale: 1.04 }}
            className="
              bg-white
              border border-gray-200
              rounded-xl
              px-4 py-3 
              flex items-center gap-3
              shadow-sm
              hover:shadow-lg
              transition-all duration-300
              hover:-translate-y-1
              hover:border-teal-400
              text-gray-800
              text-sm
              font-medium
            "
          >
            <div className="bg-teal-50 p-2 rounded-lg shadow-sm">
              <FaPlaneDeparture className="text-teal-600 text-lg" />
            </div>
            <span className="truncate">{route}</span>
          </motion.a>
        ))}
      </div>

      <StickyCallCard />
    </div>
  );
};

export default TopRoutesList;
